import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const ArrowDownSVG: React.FC<SvgComponentProps>  = (props) => (

  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={9}
    fill="none"
    {...props}
  >
    <path
      stroke="#6D7176"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M14.6 1.458 9.167 6.892a1.655 1.655 0 0 1-2.334 0L1.4 1.458"
    />
  </svg>
)
export default ArrowDownSVG
